export default {
    VERIFY_ROUTE: {
        ACCESS_DENIED: 403
    }
}
